"use strict";

(function () {
  'use strict';

  LoadingOverlay.$inject = ['MessageController', 'OVERLAY_EVENTS'];
  /* @ngInject */

  function LoadingOverlay(MessageController, OVERLAY_EVENTS) {
    return {
      show: function show(message) {
        MessageController.publish(OVERLAY_EVENTS.lrOverlayGroup, OVERLAY_EVENTS.lrOverlayOpen, message);
      },
      hide: function hide(message) {
        MessageController.publish(OVERLAY_EVENTS.lrOverlayGroup, OVERLAY_EVENTS.lrOverlayClose, '');
      }
    };
  }

  loadingOverlayCtrl.$inject = ['MessageController', 'OVERLAY_EVENTS'];
  /* @ngInject */

  function loadingOverlayCtrl(MessageController, OVERLAY_EVENTS) {
    var vm = this;
    MessageController.subscribe(OVERLAY_EVENTS.lrOverlayGroup, function (event, message) {
      if (event === OVERLAY_EVENTS.lrOverlayOpen) {
        vm.loadingText = 'Loading. Please wait...';

        if (message) {
          vm.loadingText = 'Loading ' + message + '. Please wait...';
        }

        vm.visible = true;
      }

      if (event === OVERLAY_EVENTS.lrOverlayClose) {
        vm.loadingText = '';
        vm.visible = false;
      }
    });
  }

  angular.module('loading-overlay', []).constant('OVERLAY_EVENTS', {
    lrOverlayGroup: 'overlay-group',
    lrOverlayOpen: 'overlay-open',
    lrOverlayClose: 'overlay-close'
  }).component('loadingOverlay', {
    controller: loadingOverlayCtrl,
    template: '<div class="loading-overlay modal--light" ng-if="$ctrl.visible">' + '<div class="loading-overlay--content">' + '<div class="loading-overlay--text text-center">' + //'<i class="fa fa-circle-o-notch fa-spin"></i> {{$ctrl.loadingText || "Loading"}}' +
    // '<svg width="100px" height="100px">' +
    // '<path id="loading-cog" fill="#0070BA" d="M94.9,41.31c-0.199-0.795-0.498-1.093-1.391-1.192c-1.036-0.104-2.1-0.287-3.176-0.454 	c-0.986-3.859-2.518-7.499-4.497-10.842c0.659-0.885,1.324-1.766,2.01-2.612c0.498-0.695,0.498-1.192,0-1.887 	c-3.277-4.768-7.252-8.841-12.019-12.119c-0.697-0.497-1.292-0.695-2.088,0c-0.831,0.673-1.688,1.322-2.544,1.97 	c-3.34-1.981-6.978-3.514-10.835-4.502c-0.217-1.458-0.434-2.928-0.626-4.421c-6.16-1.292-12.219-1.292-18.477-0.298 	c-0.894,0.1-1.291,0.397-1.391,1.391c-0.107,1.132-0.3,2.264-0.472,3.396c-3.778,0.993-7.343,2.505-10.621,4.452 	c-0.92-0.684-1.835-1.375-2.714-2.086c-0.596-0.496-0.993-0.596-1.689-0.099c-4.868,3.377-9.04,7.45-12.317,12.417 	c-0.198,0.397-0.198,1.192,0.1,1.59c0.628,0.908,1.309,1.862,2.036,2.765c-1.997,3.362-3.538,7.026-4.529,10.912 	c-1.123,0.162-2.246,0.328-3.368,0.528c-0.397,0-0.993,0.596-1.093,0.994c-1.192,5.861-1.192,11.623,0,17.482 	c0.1,0.398,0.696,0.994,1.093,1.093c1.104,0.232,2.242,0.457,3.393,0.63c0.994,3.859,2.534,7.498,4.522,10.839 	c-0.642,0.86-1.289,1.717-1.955,2.539c-0.497,0.694-0.596,1.192-0.099,1.887c3.377,4.868,7.45,8.939,12.317,12.317 	c0.695,0.498,1.192,0.498,1.887-0.099c0.861-0.7,1.776-1.314,2.659-1.95c3.336,1.952,6.964,3.457,10.809,4.423 	c0.161,1.096,0.318,2.192,0.44,3.288c0.099,0.795,0.397,1.192,1.192,1.292c5.861,1.093,11.622,1.093,17.483-0.1 	c0.496-0.1,0.993-0.694,1.093-1.093c0.219-1.149,0.433-2.329,0.602-3.506c3.794-1,7.375-2.522,10.664-4.485 	c0.895,0.666,1.785,1.339,2.641,2.031c0.696,0.497,1.191,0.597,1.889,0.1c4.866-3.377,8.94-7.45,12.218-12.318 	c0.199-0.396,0.199-1.291-0.1-1.688c-0.669-0.949-1.342-1.895-2.046-2.825c1.944-3.306,3.453-6.899,4.429-10.709 	c1.166-0.176,2.333-0.36,3.479-0.573c0.396-0.099,0.894-0.595,0.993-0.993c0.299-1.589,0.595-3.277,0.694-4.867 	C95.894,49.754,95.694,45.482,94.9,41.31z M50,85.334c-19.515,0-35.334-15.819-35.334-35.334c0-19.514,15.819-35.334,35.334-35.334 	c19.514,0,35.334,15.82,35.334,35.334C85.334,69.515,69.514,85.334,50,85.334z"/>' +
    // '<path fill="#0070BA" d="M68.788,49.331v10.886v14.189h-13.98V60.959h-9.613v13.447h-13.98V60.217V49.331l18.787-15.1L68.788,49.331z	 M73.212,44.447L50,25.594L26.788,44.447v6.423L50,32.018l23.21,18.853v-6.423H73.212z"/>' +
    // '</svg>' +
    '<svg width="129px" height="138.555px">' + '<path class="path" fill="#FFFFFF" stroke="#0070ba" stroke-width="3" stroke-miterlimit="10" d="M125.878,53.54L65,4.094L4.122,53.54v16.85L65,20.94l60.874,49.449V53.54H125.878z"/>' + '<path class="path" fill="#FFFFFF" stroke="#0070ba" stroke-width="3" stroke-miterlimit="10" d="M114.276,66.348V94.9v37.215H77.609V96.847H52.396v35.269H15.73V94.9V66.348l49.272-39.602L114.276,66.348z"/>' + '</svg>' + '<div>{{$ctrl.loadingText}}</div>' + '</div>' + '</div>' + '</div>'
  }).factory('LoadingOverlay', LoadingOverlay);
})();